import { ComponentProps, forwardRef } from "react";
import { Tabs as BaseTab } from "@base-ui-components/react/tabs";
import { tabPanelClasses } from "./TabPanel.style";

export type TabPanelProps = ComponentProps<typeof BaseTab.Panel>;

const TabPanel = forwardRef<HTMLDivElement, TabPanelProps>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <BaseTab.Panel
      className={tabPanelClasses({
        className: typeof className === "string" ? className : "",
      })}
      ref={ref}
      {...rest}
    />
  );
});

TabPanel.displayName = "TabPanel";

export default TabPanel;
